module.exports = __webpack_public_path__ + "f22194e9415e6011dcdaf01e9967f28b.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/press_teaser_201604_sputnika.jpg
// module id = 642
// module chunks = 0